<template>
    <div>

        <form class="form-horizontal" >

            <div class="form-group">

                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>

                <div class="col-sm-3">
                    <label class="control-label">PORTA INICIAL</label>
                    <input disabled type="text" v-model="contrato.porta_inicial" class="form-control" >
                </div>

                <div class="col-sm-3">
                    <label class="control-label">PORTA FINAL</label>
                    <input disabled type="text" v-model="contrato.porta_final" class="form-control" >
                </div>
            </div>

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-wifi" aria-hidden="true"></i> ROTEAMENTO DE PORTAS NO RÁDIO
                </div>
                <div class="panel-body">
                    <div class="form-group">
                        <label for="inputUsuario" class="col-sm-2 control-label">INICIAL:</label>
                        <div class="col-sm-2">
                            <input type="text" v-model.number="porta.porta_inicial" class="form-control" id="inputUsuario">
                        </div>
                        <label for="inputSenha" class="col-sm-1 control-label">FINAL:</label>
                        <div class="col-sm-2">
                            <input type="text" v-model.number="porta.porta_final" class="form-control" id="inputSenha">
                        </div>
                        <label for="inputIp" class="col-sm-1 control-label">IP:</label>
                        <div class="col-sm-3">
                            <input type="text" v-model="porta.ip" class="form-control" id="inputIp" placeholder="###.###.###.###">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="coment" class="col-sm-2 control-label">COMENTÁRIO:</label>
                        <div class="col-sm-10">

                            <textarea rows="3" v-model="porta.comentario" class="form-control" id="coment"></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="protocolo" class="col-sm-2 control-label">PROTOCOLO:</label>
                        <div class="col-sm-2">
                            <select v-model="porta.protocolo" class="form-control" id="protocolo">
                                <option value="tcp">TCP</option>
                                <option value="udp">UDP</option>
                            </select>
                        </div>
                        <label for="inputIp" class="col-sm-1 control-label"></label>
                        <div class="col-sm-7">
                            <button :disabled="!itsOK" type="button" @click="enviarPorta()" class="btn btn-warning">ENVIAR PORTAS PARA O ROTEADOR</button>
                        </div>
                    </div>
                </div>
            </div>

        </form>

        <div class="panel panel-info">
            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-wifi" aria-hidden="true"></i> PORTAS NO RÁDIO
            </div>
            <div class="panel-body">
                <pre>{{ portas }}</pre>
            </div>
        </div>

    </div>
</template>
<script>
/* global swal */
import { Contratos } from "../../../class/index";
import contratoMixin from "../../mixins/contrato";

export default {
    name: "ContratosPortas",
    mixins: [contratoMixin],
    data() {
        return {
            porta: this.clean(),
            portas: "Buscando Porta"
        };
    },
    computed: {
        itsOK: function() {
            try {
                if (!this.porta.porta_final || !this.porta.porta_inicial) {
                    return false;
                }

                if (this.porta.porta_inicial < this.contrato.porta_inicial) {
                    return false;
                }

                if (!this.porta.ip) {
                    return false;
                }
            } catch (e) {
                return false;
            }

            return true;
        }
    },
    beforeMount() {
        this.buscar();
    },
    methods: {
        clean() {
            return {
                ip: null,
                porta_inicial: null,
                porta_final: null,
                comentario: null,
                contrato_id: null,
                protocolo: "tcp"
            };
        },
        buscar() {
            Contratos.getPortas(this.contrato_id).then(
                data => (this.portas = data.data)
            );
        },
        enviarPorta() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Enviar Comando",
                    text: "Posso enviar a porta para o roteador?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise((resolve, reject) => {
                            this.porta.contrato_id = this.contrato._id;

                            Contratos.sendPortas(this.porta)
                                .then(data => {
                                    console.log(data);
                                    this.buscar();
                                    this.porta = this.clean();
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    reject(err);
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
